// @flow
import React, { type Node, useMemo } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import PlainTooltip from 'app/common/ui-next/plain-tooltip';
import PlainButton from 'app/common/ui-next/plain-button';
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link';
import PlainIcon, { iconTypes, colorTypes } from 'app/common/ui-next/plain-icon';
import { toFixedValueCurrency } from 'app/common/lib/toFixedValue';
import { useCurrencySign } from 'app/common/components-next/currency';

import styles from './OrderFormFooter.module.scss';;


type Props = {
  className?: string,
  orderTotal?: number,
  disabled?: boolean,
  loading?: boolean,
  sending: boolean,
  onOrderClear: () => void,
  onOrderSubmit: (e: SyntheticEvent<HTMLElement>) => Promise<void>,
}

const OrderFormFooter = ({
  className,
  orderTotal,
  disabled,
  loading,
  sending,
  onOrderClear,
  onOrderSubmit,
}: Props): Node => {
  const { t } = useTranslation('cafeteria');
  const currency = useCurrencySign();

  const totalString = useMemo(() => (
    `${t('order_form_total', 'Итого')} ${toFixedValueCurrency(orderTotal, false, currency)}`
  ), [orderTotal, t, currency]);

  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.total}>
        {totalString}
      </div>

      <div className={styles.space} />

      {!disabled
        && <PlainButtonAsLink onClick={onOrderClear}>
          <PlainTooltip text={t('order_form_clear_order_tooltip', 'Очистить заказ')}>
            <PlainIcon
              className={styles.clearIcon}
              type={iconTypes.CROSS_BOLD}
            />

          </PlainTooltip>
        </PlainButtonAsLink>}

      <PlainButton
        disabled={disabled || sending || loading}
        onClick={onOrderSubmit}
      >
        {sending
          ? t('order_form_bt_order_process', 'Заказывается...')
          : t('order_form_bt_order', 'Заказать')}
        &nbsp;
        <PlainIcon
          type={iconTypes.CHECKED}
          colorType={colorTypes.COLOR_WHITE}
        />
      </PlainButton>
    </div>
  );
};

export default OrderFormFooter;
